import type { TRootState } from 'store';

export const isWebAudioAccessGranted = (state: TRootState) =>
  state.audioInput.webAudioAccessGranted;
export const getMicrophoneAccess = (state: TRootState) => state.audioInput.microphoneAccess;
export const getBrowserNotSupported = (state: TRootState) => state.audioInput.browserNotSupported;
export const isMicrophoneActive = (state: TRootState) => state.audioInput.microphoneIsActive;
export const isListening = (state: TRootState) => state.audioInput.listening;
